<template>
  <v-app>
    <v-layout row justify-center>
      <v-flex class="pl-4 pr-4 mt-3 mb-4" xs12 sm11>
        <v-card>
          <v-toolbar color="grey" dark dense>
            <v-toolbar-title>Usuarios</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <v-toolbar-items>
                  <v-btn dark text v-on="on">
                    Nuevo
                  </v-btn>
                </v-toolbar-items>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-select
                          :items="listRoles"
                          v-model="editedItem.role"
                          label="Role"
                          item-value="id"
                          item-text="name"
                          :rules="notBlankRules"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model.trim="editedItem.name" label="Nombre" :rules="notBlankRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model.trim="editedItem.email" label="Email" :rules="emailRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 v-if="editedItem.role > 2">
                          <v-select
                            :items="listMagistrados"
                            v-model="editedItem.magistrado_id"
                            label="Magistrado"
                            item-value="id"
                            item-text="ncompleto"
                            :rules="notBlankRules"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 v-if="editedItem.role > 2">
                          <v-select
                            :items="listSalas"
                            v-model="editedItem.sala_id"
                            label="Sala"
                            item-value="id"
                            item-text="nombre"
                            :rules="notBlankRules"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-checkbox
                            v-if="editedIndex > -1"
                            v-model="activo"
                            label="Activo"
                            :value="activo"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs12>
                          <v-checkbox v-if="editedIndex > -1"
                            v-model="changePassword"
                            label="Cambiar Contraseña"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs12 v-if="editedIndex == -1 || changePassword">
                          <v-text-field v-model.trim="editedItem.password" label="Contraseña" :type="show ? 'text' : 'password'"
                                        :rules="notBlankRules"
                          >
                          </v-text-field>
                          <v-text-field v-model.trim="editedItem.password_confirmation" label="Confirmar Contraseña" :type="show ? 'text' : 'password'"
                                        :rules="notBlankRules"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" dark @click.native="close">Cancelar</v-btn>
                          <v-btn v-if="editedIndex > -1" color="yellow darken-2" @click.native="editUser(editedItem)" :disabled="!valid" :loading="loading" class="white--text">Actualizar</v-btn>
                          <v-btn v-else color="yellow darken-2" @click.native="addUser(editedItem)" :disabled="!valid" :loading="loading" class="white--text">Guardar</v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-toolbar>

          <v-card-title>
            <v-select
              label="Filtrar por Sala"
              item-text="nombre"
              item-value="id"
              :items="listSalas"
              v-model="search"
              clearable
              @change="getUsers()"
            ></v-select>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="listUsers"
            item-key="user"
            class="elevation-1"
            light
            actions
            :loading="loading"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            @page-count="pageCount = $event"
          >
            <template v-slot:item.action="{ item }">
              <v-icon color="orange"  class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon v-if="!item.deleted_at" color="red"  @click="deleteUser(item)">mdi-close</v-icon>
            </template>
            <template v-slot:item.magistrado_data.primer_apellido="{ item }">
              <div v-if="item.magistrado_data">
                {{ item.magistrado_data.nombre }}
                {{ item.magistrado_data.primer_apellido }}
                {{ item.magistrado_data.segundo_apellido }}
              </div>
            </template>
            <template v-slot:item.activo="{ item }">
              <v-icon
                  v-if="!item.deleted_at"
                  class="mr-2"
                  color="green"
              >mdi-check-bold</v-icon>
              <v-icon
                  v-else
                  class="mr-2"
                  color="grey"
              >mdi-minus</v-icon>
            </template>
          </v-data-table>
          <div class="text-center pt-2" v-if="listUsers.length > itemsPerPage">
            <v-pagination v-model="page" :length="pageCount" :total-visible='7'></v-pagination>
          </div>

        </v-card>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
const Swal = require('sweetalert2');
export default {

  data() {
    return {
      search:'',
      activo: true,
      changePassword:false,
      valid: true,
      dialog: false,
      loading:false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      show: false,
      headers: [
        { text: 'Usuario', value: 'name', sortable: false, align: 'left' },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Rol', value: 'roles[0].name', sortable: false },
        { text: 'Sala', value: 'sala_data.nombre', sortable: false },
        { text: 'Magistrado', value: 'magistrado_data.primer_apellido', sortable: false },
        { text: 'Activo', value: 'activo', sortable: true },
        { text: 'Acciones', value: 'action', sortable: false, width: '9%' }
      ],
      editedIndex: -1,
      editedItem: {
        role:'',
        name:'',
        magistrado_id:'',
        sala_id:'',
        email:'',
        password: '',
        password_confirmation:'',
      },
      defaultItem: {
        role:'',
        name:'',
        magistrado_id:'',
        sala_id:'',
        email:'',
        password: '',
      },
      message: '',
      notBlankRules: [v => !!v || 'Este campo es requerido'],
      emailRules: [
        v => !!v || 'El campo es requerido',
        v => /.+@.+\..+/.test(v) || 'Ingrese un correo valido',
      ]
    }
  },
  created() {
    this.$store.commit("SET_LAYOUT", "dashboard-layout");
  },
  computed: {
    ...mapGetters([
      "listUsers",
      "listRoles",
      "listMagistrados",
      "listSalas",
    ]),
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Usuario' : 'Editar Usuario'
    },
  },
  mounted() {
    this.getUsers();
    this.getRoles();
    this.getMagistrados();
    this.getSalas();
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  methods: {
    getUsers() {
      this.loading = true;
      this.filtro = {
        sala_id: this.search,
      }
      this.$store.dispatch("GET_USERS", { url: "/users", data: this.filtro }).then((response) => {
        this.loading = false;
      })
      .catch(err => {
        console.log(err);
      });
    },
    getRoles() {
      this.$store.dispatch("GET_ROLES",  { url: "/roles" }).then((response) => {
      })
      .catch(err => {
        console.log(err);
      });
    },
    getMagistrados() {
      this.$store.dispatch("GET_MAGISTRADOS",  { url: "/magistrados" }).then((response) => {
      })
      .catch(err => {
        console.log(err);
      });
    },
    getSalas() {
      this.$store.dispatch("GET_SALAS",  { url: "/salas" }).then((response) => {
      })
      .catch(err => {
        console.log(err);
      });
    },

    editItem (item) {
      this.editedIndex = this.listUsers.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.role = item.roles[0].id
      if (item.magistrado_data) {
        this.editedItem.magistrado_id = item.magistrado_data.id
        this.editedItem.sala_id = item.sala_data.id
      }
      if (this.editedItem.deleted_at) this.activo = false
      else this.activo = true
      this.dialog = true
    },
    addUser(item){
      if (this.editedItem.password != this.editedItem.password_confirmation) {
        this.$swal({
          icon: 'error',
          title: 'Error!!!',
          text: 'Las contraseñas no coinciden, favor de verificarlas.',
          confirmButtonText: "Aceptar"
        })
        return false;
      }
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store.dispatch("SAVE_USERS",  { url: "/user", data: item } ).then(response => {
          this.close ();
          this.$swal({
            icon: 'success',
            title: 'Usuario guardado correctamente',
            confirmButtonText: "Aceptar"
          })
          this.getUsers();
        })
        .catch(error => {
          console.log(error);
        });
      }
    },
    editUser(item){
      if (this.editedItem.password != this.editedItem.password_confirmation) {
        this.$swal({
          icon: 'error',
          title: 'Error!!!',
          text: 'Las contraseñas no coinciden, favor de verificarlas.',
          confirmButtonText: "Aceptar"
        })
        return false;
      }
      if (this.$refs.form.validate()) {
        this.loading = true;
        item.activo = true
        this.$store.dispatch("EDIT_USER",  { url: "/user/" + item.id, data: item } ).then(response => {
          this.$swal({
            icon: 'success',
            title: 'Usuario actualizado correctamente.',
            confirmButtonText: "Aceptar"
          })
          this.close();
          this.getUsers();
        })
        .catch(error => {
          console.log(error);
        });
      }
    },
    deleteUser(item){
      this.$swal({
        title: '¿Desea eliminar al usuario "' + item.name + '"?',
        text: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: "Aceptar"
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          this.$store.dispatch("DELETE_USER",  { url: "/user/" + item.id } ).then(res => {
            Swal.fire({
              icon: 'success',
              title: 'Usuario eliminado correctamente.',
              confirmButtonText: "Aceptar"
            })
            this.getUsers();
          })
          .catch(err => {
            console.log(err);
          });
        }
      })
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.$refs.form.reset()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.dialog = false
      }, 300)
    },
  }
}
</script>
